import actions from './actions';

const initState = {
  isLoading: false,
  errorMessage: false,
  roles: [],
  permissions: [],
  modalActive: false
};

export default function reducer(state = initState, { type, payload }) {
  switch (type) {
    case actions.LOAD_FROM_API:
      return {
        ...state,
        errorMessage: false
      };
    case actions.LOAD_FROM_API_SUCCESS:
      return {
        ...state,
        roles: payload.data,
        errorMessage: false
      };
    case actions.LOAD_PERMISSIONS_FROM_API_SUCCESS:
      return {
        ...state,
        permissions: payload.data?.role_permissions,
        errorMessage: false
      };
    case actions.LOAD_FROM_API_ERROR:
      return {
        ...state,
        errorMessage: 'There is a loading problem'
      };
    case actions.TOGGLE_LOADING:
      return {
        ...state,
        isLoading: payload.value
      };
    case actions.TOGGLE_API_HANDLE_MODAL:
      return {
        ...state,
        modalActive: !state.modalActive,
        rolePermission: payload.data == null ? initState.rolePermission : payload.data
      };
    default:
      return state;
  }
}
